'use server'

import { captureException } from '@sentry/nextjs'
import { addBreadcrumb } from '@sentry/nextjs'
import { getNextCookies } from '../cookies/getNextCookies'
import { AMZN_HEADERS } from '../getBearerToken/constants'

export async function getBearerTokenServerAction(): Promise<
  string | undefined
> {
  const { access, refresh } = await getNextCookies()

  if (!refresh) {
    addBreadcrumb({
      message: 'No valid refresh cookie',
      data: {
        access,
      },
    })

    return undefined
  }

  if (!access) {
    addBreadcrumb({
      message: 'No valid access token found',
    })

    try {
      const response = await fetch(refresh.iss, {
        method: 'POST',
        body: JSON.stringify({
          AuthFlow: 'REFRESH_TOKEN_AUTH',
          AuthParameters: {
            REFRESH_TOKEN: refresh?.token,
          },
          ClientId: process.env['NEXT_PUBLIC_AMP_WEB_CLIENT_ID'],
          ClientMetadata: {},
        }),
        headers: AMZN_HEADERS,
      })

      if (response.ok) {
        addBreadcrumb({
          message: 'Refresh token request ok',
        })

        const jsonResponse = await response.json()
        const { AccessToken } = jsonResponse?.AuthenticationResult || {}

        return AccessToken
      } else {
        addBreadcrumb({
          message: 'Refresh token request failed',
        })
      }

      return undefined
    } catch (e) {
      captureException(e)
      return undefined
    }
  }

  return access?.token
}
